export function SendMessageToCSharp(message) {
  window.HybridWebView.SendRawMessageToDotNet(message);
}
